module.exports = __webpack_public_path__ + "img/bg1.27832325.png";